export class AgencyGroup {
  id: string;
  name: string;
  status: string;
  taxCode: string;
}
